module.exports = "\n{{{ loadingIndicator }}}\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoadingView.vue
// module id = 111
// module chunks = 0